module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-Navi-Hype-Reel-Video.7329872a.webp";